import { render, staticRenderFns } from "./answer-public-background.vue?vue&type=template&id=149bbe03&scoped=true&"
import script from "./answer-public-background.vue?vue&type=script&lang=js&"
export * from "./answer-public-background.vue?vue&type=script&lang=js&"
import style0 from "./answer-public-background.vue?vue&type=style&index=0&id=149bbe03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149bbe03",
  null
  
)

export default component.exports